module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/movie-e5a636e8fceb83b155901fec088965bc.svg";